import { render, staticRenderFns } from "./PlacementResultTestTableForm.vue?vue&type=template&id=1bcddfb7"
import script from "./PlacementResultTestTableForm.vue?vue&type=script&lang=js"
export * from "./PlacementResultTestTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports